import { fileUrl } from "@/lib/api";
import { areaText, inr } from "@/lib/format";

export function propertySummary(p, company = "PERFORMED REAL ESTATE LLP") {
  const title = p.listing_type === "Purchase requirement" ? "Requirement" : `For ${p.listing_type}`;
  const lines = [
    `*${company}*`,
    `*${title}: ${p.property_type}${p.bhk ? ` – ${p.bhk}` : ""}*`,
    p.project && `Project: ${p.project}`,
    `Location: ${[p.sector, p.city].filter(Boolean).join(", ") || "—"}`,
    p.area && `Area: ${areaText(p.area, p.area_unit)}`,
    p.price && `${p.listing_type === "Rent" ? "Rent" : "Price"}: ${inr(p.price)}${p.listing_type === "Rent" ? "/month" : ""}${p.negotiable ? " (negotiable)" : ""}`,
    p.price_per_sqft && p.listing_type !== "Rent" && `Rate: ${inr(p.price_per_sqft)}/sq ft`,
    p.floor && `Floor: ${p.floor}`,
    p.facing && `Facing: ${p.facing}`,
    p.possession && `Possession: ${p.possession}`,
    p.ownership && `Ownership: ${p.ownership}`,
    p.maps_link && `Map: ${p.maps_link}`,
    "",
    `Contact ${company} for details and site visit.`,
  ];
  return lines.filter((l) => l !== false && l !== null && l !== undefined && l !== "" || l === "").join("\n");
}

export async function shareProperty(p, company) {
  const text = propertySummary(p, company || undefined);
  const photos = (p.photos || []).slice(0, 4);
  if (navigator.canShare && photos.length) {
    try {
      const files = await Promise.all(
        photos.map(async (ph, i) => {
          const r = await fetch(fileUrl(ph.path), { credentials: "include" });
          const b = await r.blob();
          return new File([b], ph.name || `photo-${i + 1}.jpg`, { type: b.type || "image/jpeg" });
        }),
      );
      if (navigator.canShare({ files })) {
        await navigator.share({ files, text });
        return;
      }
    } catch (e) {
      if (e?.name === "AbortError") return;
    }
  }
  window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, "_blank", "noopener");
}
